/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import EMShero from "parts/EMSHero";
import Thechallenge from "parts/Thechallenge";
import SeeAction from "parts/SeeAction";
import WhoItsFor from "parts/Whoitsfor";
import Footer from "parts/Footer";
import Theplatform from "parts/Platform";
import HowEngage from "parts/HowEngage";
import TestimonialEms from "parts/TestimonialEms";
import WhyNube from "parts/WhyNube";
import CTAEms from "parts/CTAEms";

export default class EMSPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>
            Nube iO Smart Energy Management for Building Portfolios
          </title>
          <meta
            name="description"
            content="Nube iO delivers end-to-end energy management for building teams — device to dashboard, across electricity, water, gas & solar. NABERS, Green Star, ESG & NCC built in."
          />
          <meta
            name="keywords"
            content="energy management system Australia; NABERS reporting software; multi-site energy monitoring; building energy compliance; NCC energy reporting; ESG building data"
          />
          <link rel="canonical" href="https://nube-io.com/ems/" />
          <meta
            property="og:title"
            content="Nube iO Smart Energy Management for Building Portfolios"
          />
          <meta
            property="og:description"
            content="Nube iO delivers end-to-end energy management for building teams — device to dashboard, across electricity, water, gas & solar. NABERS, Green Star, ESG & NCC built in."
          />
          <meta property="og:url" content="https://nube-io.com/ems/" />
        </Helmet>
        <Header1 />
        <EMShero />
        <Thechallenge />
        <SeeAction />
        <Theplatform />
        <WhoItsFor />
        <TestimonialEms />
        <HowEngage />
        <WhyNube />
        <CTAEms />
        <Footer />
      </>
    );
  }
}
